











import Vue from 'vue'
import {Dictionary} from 'vuex'
import TableConfig from '@/activeTables/resp/resp'
import activeTable from '@/components/Ui/ActiveTable/ActiveTable.vue'
import store from '@/store'

export default Vue.extend({
  name: 'respList',
  props: {
    active: Boolean
  },
  components: {
    activeTable
  },
  data () {
    return {
      config: TableConfig,
      loaded: false,
      interval: null
    }
  },
  methods: {
    dataWatcher (): void {
      // @ts-ignore
      let self = this;
      // @ts-ignore
      self.interval = setInterval(() => {
        // @ts-ignore
        // self.reloadMailing();
      }, 4000)
    },
    reloadMailing (): void {
      // @ts-ignore
      this.$refs.table.loadList()
    },
    clearInterval (): void {
      // @ts-ignore
      clearInterval(this.interval)
    }
  },
  async mounted () {
    this.loaded = true
    // @ts-ignore
    this.dataWatcher();
    this.$root.$on('relogin', this.clearInterval)
  },
  beforeDestroy () {
    // @ts-ignore
    clearInterval(this.interval)
    this.clearInterval()
    this.$root.$off('relogin', this.clearInterval)
  }
})
